import { Router } from '@angular/router';
import { ActionTypeEnum } from '../action-types';
import { ActionTypeHandlerBaseSmartEnum, ActionTypeHandlerEnum } from './action-type-handler.enum';
import { IActionExecutedEvent, IBaseActionConfig } from '../../types';
import { OutputEmitterRef } from '@angular/core';

export interface IRedirectActionConfig<TEntity> extends IBaseActionConfig<IRedirectHandlerConfig<TEntity>> {
  type: ActionTypeEnum;
  handlerType: ActionTypeHandlerEnum.REDIRECT;
}

export interface IRedirectHandlerConfig<TEntity> {
  router: Router;
  urlResolver: (item: TEntity) => string;
}

export class RedirectActionTypeHandlerSmartEnum extends ActionTypeHandlerBaseSmartEnum {
  public static Redirect = new RedirectActionTypeHandlerSmartEnum(ActionTypeHandlerEnum.REDIRECT);

  constructor(name: string) {
    super(name);
  }

  override execute<TEntity>(
    { handlerConfig: config }: IRedirectActionConfig<TEntity>,
    item: TEntity,
    actionExecuted?: OutputEmitterRef<IActionExecutedEvent<TEntity>>
  ) {
    if (!config.router) {
      throw new Error(`Redirect handler requires a valid Angular Router instance`);
    }

    if (!config.urlResolver) {
      throw new Error(`Redirect handler requires a valid URL`);
    }

    config.router.navigate([config.urlResolver(item)], { state: { item: item } });
  }
}
